import { useState } from 'react';
import { toast } from 'react-toastify';
import { changePassword } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import styles from './ChangePasswordRequiredPage.module.css';

const ChangePasswordRequiredPage = () => {
  const { refreshUser, updateToken } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.newPassword !== form.confirmPassword) { toast.error('New passwords do not match'); return; }
    setLoading(true);
    try {
      const result = await changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
      toast.success('Password changed successfully');
      // The old token is now invalid (password change bumps passwordChangedAt server-side),
      // so the new one must be stored before any further authenticated request, including refreshUser().
      if (result?.token) updateToken(result.token);
      await refreshUser();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.title}>Set a New Password</div>
        <div className={styles.subtitle}>
          You're logging in with a temporary password. Please set your own password before continuing.
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Current (Temporary) Password *</label>
            <input name="currentPassword" type="password" value={form.currentPassword} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label>New Password *</label>
            <input name="newPassword" type="password" value={form.newPassword} onChange={handleChange} required minLength={6} placeholder="At least 6 characters" />
          </div>
          <div className="form-group">
            <label>Confirm New Password *</label>
            <input name="confirmPassword" type="password" value={form.confirmPassword} onChange={handleChange} required minLength={6} />
          </div>
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Updating…' : 'Set Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordRequiredPage;
